export class Seismograph {
  id!: number;
  serialNumber!: string;
  model: string | undefined;
  lastUsed: Date | undefined;
  lastCalibration: Date | undefined;
  isDeleted: boolean = false;
  isFavorite: boolean = false;
  //seismographSerialNumber: string | undefined;
  companyId: number | undefined;
  username: string | undefined;
  controlPointId: number | undefined;
  batteryLevel: number | undefined;
  lastStatusDate: Date | undefined;
  connected: boolean | undefined;
  minutesAgo: number | undefined;
  siteId: number | undefined;
  workingStatus: string | undefined;
  timeZoneName: string | undefined;
  timeZoneDisplayName: string | undefined;
  timeZoneId: number | undefined;
}